import React from "react";

const TextInput = (props) => {
  const { label, required, value, onChange, readOnly } = props;

  const onOnChange = (e) => {
    onChange(e.target.value);
  }
  return (
    <div className="field">
      <label className="label">
        {label}
        {required ? <span className="required">&nbsp;*</span> : null}
      </label>
      <div className="control">
        <input
          className="input"
          type="text"
          placeholder={label}
          value={value}
          onChange={onOnChange}
          disabled={readOnly}
        />
      </div>
    </div>
  );
};

export default TextInput;
